(() => {
  if (window.acquaAnnouncementsLoaded) return;
  window.acquaAnnouncementsLoaded = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const controllers = new WeakMap();
  const parseTime = (value) => {
    if (!value) return null;
    if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(value)) return NaN;
    return Date.parse(value);
  };
  const safeStorage = (action, key) => {
    try { return action === 'get' ? sessionStorage.getItem(key) : sessionStorage.setItem(key, '1'); }
    catch { return null; }
  };
  const init = (root) => {
    controllers.get(root)?.destroy();
    const track = root.querySelector('[data-acqua-announcement-track]');
    if (!track) return;
    const items = [...track.querySelectorAll('[data-acqua-announcement-item]')];
    if (!items.length) return;
    const pause = root.querySelector('[data-acqua-announcement-pause]');
    const next = root.querySelector('[data-acqua-announcement-next]');
    const close = root.querySelector('[data-acqua-announcement-close]');
    const key = `acqua-announcement:${root.dataset.dismissKey}`;
    const designMode = Boolean(window.Shopify?.designMode);
    const start = parseTime(root.dataset.start);
    const end = parseTime(root.dataset.end);
    let index = 0, manualPause = false, timer, scheduleTimer, destroyed = false;
    const scheduled = () => !Number.isNaN(start) && !Number.isNaN(end) && (start === null || Date.now() >= start) && (end === null || Date.now() < end);
    const updateSchedule = () => {
      root.hidden = !scheduled() || (!designMode && Boolean(safeStorage('get', key)));
      clearTimeout(scheduleTimer);
      if (!destroyed && start !== null && start > Date.now()) scheduleTimer = setTimeout(updateSchedule, Math.min(start - Date.now(), 2147483647));
      else if (!destroyed && end !== null && end > Date.now()) scheduleTimer = setTimeout(updateSchedule, Math.min(end - Date.now(), 2147483647));
    };
    const halted = () => manualPause || reduced.matches || root.matches(':hover') || root.matches(':focus-within') || document.hidden || root.hidden;
    const show = (position) => {
      index = (position + items.length) % items.length;
      if (root.dataset.mode === 'static') {
        track.style.transform = '';
        items.forEach((item, i) => item.toggleAttribute('data-editor-current', i === index));
      } else {
        track.style.transform = `translateX(-${index * 100}%)`;
      }
      if (root.dataset.mode === 'rotate') items.forEach((item, i) => {
        item.setAttribute('aria-hidden', String(i !== index));
        item.inert = i !== index;
      });
    };
    const syncPause = () => {
      if (pause) {
        pause.setAttribute('aria-pressed', String(manualPause));
        pause.setAttribute('aria-label', manualPause ? root.dataset.resumeLabel : root.dataset.pauseLabel);
        pause.textContent = manualPause ? '▶' : 'Ⅱ';
      }
      root.toggleAttribute('data-paused', manualPause || reduced.matches);
    };
    const onPause = () => { manualPause = !manualPause; syncPause(); };
    const onNext = () => show(index + 1);
    const onClose = () => { if (!designMode) safeStorage('set', key); root.hidden = true; };
    const onReduced = () => { if (reduced.matches && root.dataset.mode === 'rotate') show(0); syncPause(); };
    if (root.dataset.mode === 'rotate') {
      show(0);
      if (items.length > 1) timer = setInterval(() => { if (!halted()) show(index + 1); }, Math.max(2, Number(root.dataset.interval || 4)) * 1000);
    }
    if (root.dataset.mode === 'marquee') items.forEach((item) => {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.inert = true;
      track.appendChild(clone);
    });
    pause?.addEventListener('click', onPause);
    next?.addEventListener('click', onNext);
    close?.addEventListener('click', onClose);
    reduced.addEventListener('change', onReduced);
    updateSchedule();
    syncPause();
    controllers.set(root, { show, select: (position) => {
      root.hidden = false;
      manualPause = true;
      show(position);
      syncPause();
    }, destroy: () => {
      destroyed = true;
      clearInterval(timer);
      clearTimeout(scheduleTimer);
      pause?.removeEventListener('click', onPause);
      next?.removeEventListener('click', onNext);
      close?.removeEventListener('click', onClose);
      reduced.removeEventListener('change', onReduced);
      track.querySelectorAll('[aria-hidden=true]').forEach((node) => { if (!items.includes(node)) node.remove(); });
    } });
  };
  const scan = (scope = document) => {
    if (scope.matches?.('[data-acqua-announcement]')) init(scope);
    scope.querySelectorAll('[data-acqua-announcement]').forEach(init);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan()); else scan();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-acqua-announcement]').forEach((root) => controllers.get(root)?.destroy()));
  document.addEventListener('shopify:block:select', (event) => {
    const item = event.target.closest('[data-acqua-announcement-item]');
    const root = item?.closest('[data-acqua-announcement]');
    if (!root) return;
    const items = [...root.querySelectorAll('[data-acqua-announcement-track] > [data-acqua-announcement-item]')];
    if (root.dataset.mode === 'static') root.setAttribute('data-editor-selected', '');
    controllers.get(root)?.select(items.indexOf(item));
  });
  document.addEventListener('shopify:block:deselect', (event) => {
    const root = event.target.closest('[data-acqua-announcement]');
    if (root?.dataset.mode === 'static') {
      root.removeAttribute('data-editor-selected');
      root.querySelectorAll('[data-editor-current]').forEach((item) => item.removeAttribute('data-editor-current'));
    }
  });
})();
